import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleOAuthSuccess, handleTherapistOAuthSuccess } from '../../redux/authSlice';

const OAuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const role = searchParams.get('role');
    const error = searchParams.get('error');

    if (error) {
      // Ana pencereye hata gönder
      if (window.opener) {
        window.opener.postMessage({
          type: 'OAUTH_ERROR',
          error: error
        }, window.location.origin);
        window.close();
      } else {
        navigate('/signIn?error=' + encodeURIComponent(error));
      }
      return;
    }

    if (token && role) {
      // Ana pencereye başarılı sonucu gönder
      if (window.opener) {
        window.opener.postMessage({
          type: 'OAUTH_SUCCESS',
          token: token,
          role: role
        }, window.location.origin);
        window.close();
      } else {
        // Popup değilse, direkt olarak işle
        if (role === 'THERAPIST') {
          dispatch(handleTherapistOAuthSuccess({ token, role }))
            .unwrap()
            .then(() => {
              navigate('/therapistHomePage');
            })
            .catch(() => {
              navigate('/signInTherapist?error=oauth_failed');
            });
        } else {
          dispatch(handleOAuthSuccess({ token, role }))
            .unwrap()
            .then(() => {
              navigate('/userHomePage');
            })
            .catch(() => {
              navigate('/signIn?error=oauth_failed');
            });
        }
      }
    } else {
      if (window.opener) {
        window.opener.postMessage({
          type: 'OAUTH_ERROR',
          error: 'Token bulunamadı'
        }, window.location.origin);
        window.close();
      } else {
        navigate('/signIn?error=token_not_found');
      }
    }
  }, [searchParams, dispatch, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="mt-4 text-text">Giriş işleminiz tamamlanıyor...</p>
      </div>
    </div>
  );
};

export default OAuthSuccess;